import { render, staticRenderFns } from "./coderInpatientPxs.vue?vue&type=template&id=487cb848&scoped=true&"
import script from "./coderInpatientPxs.vue?vue&type=script&lang=js&"
export * from "./coderInpatientPxs.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientPxs.vue?vue&type=style&index=0&id=487cb848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487cb848",
  null
  
)

export default component.exports